import {
  HourMinute,
  OptionSelectableType,
  SelectOption,
} from '../shared/shared-types';

import i18n from '../../plugins/i18n';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useUtils() {
  // TODO: double zero
  const formatMinuteToHours = (
    minutes: number,
    short: boolean | null = null
  ): string => {
    const prefix = minutes < 0 ? '-' : '';

    const hours = Math.floor(Math.abs(minutes) / 60).toString();
    const mins = Math.abs(minutes) % 60;
    const stringMins = (mins < 10 ? '0' + mins : mins).toString();

    if (short === null) {
      short = true;
    }

    if (short) {
      return prefix + hours + ':' + stringMins;
    } else {
      return prefix + hours + ' óra ' + stringMins + ' perc';
    }
  };

  const formatMinutes = (totalInMinutes: number): HourMinute => {
    return {
      hours: Math.floor(totalInMinutes / 60),
      minutes: totalInMinutes % 60,
    };
  };

  // TODO: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
  const formatNumber = (value: string | number): string => {
    // TODO: !!!
    if (typeof value === 'string') {
      value = parseInt(value) / 100;
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  const getProperty = <T, R>(filter: T, property: keyof T): R => {
    const selected: unknown = filter[property];
    if (!selected) {
      throw new Error(`Property not exists: ${property}`);
    }

    return selected as R;
  };

  const createOptions = (
    input: OptionSelectableType | undefined | null,
    translationPrefix?: string,
    disabled_items?: string[]
  ): SelectOption[] => {
    if (!input) {
      return [];
    }

    return input.map((item) => {
      let label = 'not defined';
      let value: string | number = 'not defined';
      let disabled = false;

      if (typeof item === 'string') {
        label = item;
        value = item;
      }

      if (typeof item === 'number') {
        label = `${item}`;
        value = item;
      }

      if (typeof item === 'object' && 'title' in item) {
        label = item.title;
        value = item.id;
      }

      if (typeof item === 'object' && 'name' in item) {
        label = item.name;
        value = item.id;
      }

      if (translationPrefix) {
        label = i18n.global.t(`${translationPrefix}.${label}`);
      }

      if (disabled_items && disabled_items.includes(value.toString())) {
        disabled = true;
      }

      return {
        value,
        label,
        disabled
      };
    });
  };

  const calculateGross = (
    netAmount: number | string,
    vat: number | string
  ): number => {
    if (typeof netAmount === 'string') {
      netAmount = Number.parseFloat(netAmount);
    }

    if (typeof vat === 'string') {
      vat = Number.parseFloat(vat);
    }

    return netAmount * ((100 + vat) / 100);
  };

  const calculateNet = (
    grossAmount: number | string,
    vat: number | string
  ): number => {
    if (typeof grossAmount === 'string') {
      grossAmount = Number.parseFloat(grossAmount);
    }

    if (typeof vat === 'string') {
      vat = Number.parseFloat(vat);
    }

    return grossAmount / ((100 + vat) / 100);
  };

  const subtractValues = (
    from: number | string,
    it: number | string
  ): number => {
    if (typeof from === 'string') {
      from = Number.parseFloat(from);
    }

    if (typeof it === 'string') {
      it = Number.parseFloat(it);
    }

    return from - it;
  };

  const convertToRoman = (num: number): string => {
    const roman: { [key in string]: number } = {
      M: 1000,
      CM: 900,
      D: 500,
      CD: 400,
      C: 100,
      XC: 90,
      L: 50,
      XL: 40,
      X: 10,
      IX: 9,
      V: 5,
      IV: 4,
      I: 1,
    };

    let str = '';

    for (const i of Object.keys(roman)) {
      const q = Math.floor(num / roman[i]);
      num -= q * roman[i];
      str += i.repeat(q);
    }

    return str;
  };

  return {
    formatMinutes,
    formatMinuteToHours,
    formatNumber,
    getProperty,
    createOptions,
    calculateGross,
    calculateNet,
    subtractValues,
    convertToRoman,
  };
}
